import { useEffect } from 'react'
import { X, AlertCircle } from 'lucide-react'
import Card from '@/components/ui/Card'
import Button from '@/components/ui/Button'
import { cn } from '@/utils/cn'

interface ZakatAlertModalProps {
  isOpen: boolean
  message: string
  onClose: () => void
}

export default function ZakatAlertModal({
  isOpen,
  message,
  onClose,
}: ZakatAlertModalProps) {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose()
      }
    }

    if (isOpen) {
      document.addEventListener('keydown', handleEscape)
      document.body.style.overflow = 'hidden'
    }

    return () => {
      document.removeEventListener('keydown', handleEscape)
      document.body.style.overflow = 'unset'
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-50"
        onClick={onClose}
        aria-hidden="true"
      />
      <div
        className="fixed inset-0 z-50 flex items-center justify-center p-4"
        role="dialog"
        aria-modal="true"
        aria-labelledby="zakat-alert-title"
      >
        <Card className="w-full max-w-md relative bg-white dark:bg-gray-800">
          <button
            onClick={onClose}
            className="absolute top-4 left-4 p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
            aria-label="Close"
          >
            <X className="w-6 h-6" />
          </button>

          <div className="flex flex-col items-center justify-center p-8 text-center">
            <div className="mb-6">
              <div className="w-20 h-20 mx-auto bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center">
                <AlertCircle className="w-10 h-10 text-red-600 dark:text-red-400" />
              </div>
            </div>

            <h3
              id="zakat-alert-title"
              className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-4"
            >
              {message}
            </h3>

            <Button
              variant="primary"
              size="lg"
              onClick={onClose}
              className="mt-6 min-w-[120px]"
            >
              موافق
            </Button>
          </div>
        </Card>
      </div>
    </>
  )
}


